import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header';
import { FooterComponent } from './shared/components/footer/footer';
import { CookieBannerComponent } from './shared/components/cookie-banner/cookie-banner';
import { TranslateService } from '@ngx-translate/core';
import { LangService, Lang } from './core/services/lang.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, CookieBannerComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  constructor(
    private translate: TranslateService,
    private langService: LangService
  ) {
    const available: Lang[] = ['fr', 'en'];
    this.translate.addLangs(available);
    this.translate.setFallbackLang('fr');

    // Priority: stored preference > browser language > default fr
    const stored = localStorage.getItem('lang') ?? '';
    const storedLang = available.includes(stored as Lang) ? (stored as Lang) : null;
    const browser = this.translate.getBrowserLang() ?? 'fr';
    const browserLang = available.includes(browser as Lang) ? (browser as Lang) : 'fr';
    const initial: Lang = storedLang ?? browserLang;

    // init() avoids triggering URL sync (the router's langSyncGuard handles URL → lang direction)
    this.langService.init(initial);
  }
}
